import { render } from "./AgentMemoryManager.vue?vue&type=template&id=27bdd3c3&scoped=true"
import script from "./AgentMemoryManager.vue?vue&type=script&lang=js"
export * from "./AgentMemoryManager.vue?vue&type=script&lang=js"

import "./AgentMemoryManager.vue?vue&type=style&index=0&id=27bdd3c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bdd3c3"]])

export default __exports__